import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { WEIGHT_METRIC, GLUCOSE_METRIC } from '../../../constants';
import Popup from '../../common/Popup';
import { useActionFilters } from '../Chart/Filters/useActionFilters';
import {
  CHART_FILTERS_TYPE,
  DATA_SOURCE_TYPE,
  VITALS_ACTIVITY_TYPE,
} from '../constants';
import Chart from '../Chart';
import DataHistoricList from '../DataHistoricList';
import { useAllDataForHistoricListOneDay } from './useAllDataForHistoricListOneDay';
import { enhance } from './enhance';
import styles from './index.styl';

const { STEPS, DISTANCE } = VITALS_ACTIVITY_TYPE;

function SingleDayGrafModal({
  intl: { formatMessage },
  type,
  openedSingleDayGrafModal,
  baseDate,
  close,
  combinedPendingDataModalRequest,
  profileTargetUser,
  profile,
}) {
  const dispatch = useDispatch();

  const { id, settings } = useMemo(
    () => (isEmpty(profileTargetUser) ? profile : profileTargetUser),
    [profileTargetUser, profile],
  );
  const mainUser = id === profile.id;

  const isWeightInKg =
    settings && settings.measurementUnitsSettings.weight === WEIGHT_METRIC.KG;
  const isMilligramsPerDeciliter =
    settings &&
    settings.measurementUnitsSettings.glucose ===
      GLUCOSE_METRIC.MG_PER_DECILITER;
  const getActionCloseByType = useActionFilters(type, true);
  const stepsOrDistance = [STEPS, DISTANCE].includes(type);

  const adaptTitle = formatMessage({
    id: `patient.healthboard.titleHistoric.${type}`,
  }).substring(4);

  const {
    dataHistoricForOneDay,
    setHistoricSourceType,
  } = useAllDataForHistoricListOneDay(type);

  const handleCloseModal = () => {
    setHistoricSourceType(DATA_SOURCE_TYPE.ALL_SOURCES);
    dispatch(getActionCloseByType.clear());
    close();
  };

  return (
    <Popup
      title={adaptTitle}
      mobileFullScreen={false}
      onClose={handleCloseModal}
      opened={openedSingleDayGrafModal}
      strictClose
      overflowVisible
      withoutAdaptive
    >
      <div className={styles.root}>
        <Chart
          formatMessage={formatMessage}
          type={type}
          activeFilter={CHART_FILTERS_TYPE.DAY.type}
          baseDate={baseDate}
          singleDayMode
          isWeightInKg={isWeightInKg}
          setHistoricSourceType={setHistoricSourceType}
          mainUser={mainUser}
          isMilligramsPerDeciliter={isMilligramsPerDeciliter}
        />
        {!stepsOrDistance && (
          <DataHistoricList
            formatMessage={formatMessage}
            pending={combinedPendingDataModalRequest}
            type={type}
            data={dataHistoricForOneDay}
            allValuesForOneDay
            mainUser={mainUser}
            isWeightInKg={isWeightInKg}
            isMilligramsPerDeciliter={isMilligramsPerDeciliter}
          />
        )}
      </div>
    </Popup>
  );
}

SingleDayGrafModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  openedSingleDayGrafModal: PropTypes.bool,
  baseDate: PropTypes.string,
  type: PropTypes.string,
  combinedPendingDataModalRequest: PropTypes.bool,
  profile: PropTypes.object,
  profileTargetUser: PropTypes.object,
};

export default enhance(SingleDayGrafModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/SingleDayGrafModal/index.jsx